import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import NewsQueryKeys from './NewsQueryKeys';
export const newsQueryKeys = new NewsQueryKeys('news');
export const useInvalidateNewsCache = () => {
    const queryClient = useQueryClient();
    const invalidateNewsCache = useCallback(() => queryClient.invalidateQueries({ queryKey: ['news'] }), [queryClient]);
    return invalidateNewsCache;
};
